import {
  GETWORKSPACEMEMBEROKR_SUCCESS,
  GETWORKSPACEMEMBEROKR_FAIL,
} from "../actionTypes";

const initialState = {
  memberOKRs: [],
};

const workspaceMemberOKRReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETWORKSPACEMEMBEROKR_SUCCESS:
      return {
        ...state,
        memberOKRs: action.payload.user,
      };
    case GETWORKSPACEMEMBEROKR_FAIL:
      return {
        ...state,
        memberOKRs: [],
      };
    default:
      return state;
  }
};

export default workspaceMemberOKRReducer;
